<template>
	<div class="padding-lg">
		<div class="padding-xl bg-white radius solid">
			<div class="text-xxl text-black solid-bottom">{{ $route.meta.title }}</div>
			<el-divider></el-divider>
			<div class="padding-top-xl">
				<div class="padding-tb">
					<div class="infoshow">
						<div class="title">登陆账号：</div>
						<div class="con">
							<span class="text-lg text-blue">{{ info.username }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">登陆次数：</div>
						<div class="con">
							<span>{{ info.logintimes }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">首次登陆：</div>
						<div class="con">
							<span>{{ info.firstlogintime }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">最后登陆：</div>
						<div class="con">
							<span>{{ info.lastlogintime }}</span>
						</div>
					</div>
				</div>
				<div class="padding"><el-divider content-position="left">个人档案</el-divider></div>
				<div class="padding-tb">
					<div class="infoshow">
						<div class="title">&nbsp;</div>
						<div class="con padding-left-lg"><el-avatar :src="info.profile.avatar" :size="96"></el-avatar></div>
					</div>
					<div class="infoshow">
						<div class="title">姓名：</div>
						<div class="con">
							<span>{{ info.profile.name }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">手机：</div>
						<div class="con">
							<span>{{ info.profile.mobile }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">性别：</div>
						<div class="con">
							<span>{{ info.profile.gender }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">生日：</div>
						<div class="con">
							<span>{{ info.profile.birthday }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">QQ号码：</div>
						<div class="con">
							<span>{{ info.profile.qq }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">微信：</div>
						<div class="con">
							<span>{{ info.profile.weixin }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">邮箱：</div>
						<div class="con">
							<span>{{ info.profile.email }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title"></div>
						<div class="con">
							<el-button
								type="warning"
								@click="
									formModifyProfile = info.profile;
									dialogVisibleModifyProfile = true;
								"
							>
								修改资料
							</el-button>
						</div>
					</div>
				</div>
				<div class="padding"><el-divider content-position="left">账户信息</el-divider></div>
				<div class="padding-tb">
					<div class="infoshow">
						<div class="title">当前余额：</div>
						<div class="con padding-right-lg">
							<span class="text-blue text-lg text-bold" v-format="'￥,##0.00'">{{ info.account.money / 100 }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">累计充值：</div>
						<div class="con">
							<span class="text-cyan text-bold" v-format="'￥,##0.00'">{{ info.account.total / 100 }}</span>
						</div>
					</div>
				</div>
				<div class="padding"><el-divider content-position="left">代理商信息</el-divider></div>
				<div class="padding-tb">
					<div class="infoshow">
						<div class="title">代理编号：</div>
						<div class="con">
							<span>{{ info.agent.agent_id }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">名称：</div>
						<div class="con">
							<span>{{ info.agent.name }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">统一社会信用代码：</div>
						<div class="con">
							<span>{{ info.agent.creditCode }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">级别：</div>
						<div class="con">
							<span v-if="info.agent.level == 1">一级代理</span>
							<span v-else-if="info.agent.level == 2">二级代理</span>
							<span v-else-if="info.agent.level == 3">三级代理</span>
							<span v-else-if="info.agent.level == 4">四级代理</span>
							<span v-else-if="info.agent.level == 5">五级代理</span>
							<span v-else>未知</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">联系电话：</div>
						<div class="con">
							<span>{{ info.agent.telephone }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">所属地区：</div>
						<div class="con">
							<span>{{ CodeToText[info.agent.province] }}</span>
							-
							<span>{{ CodeToText[info.agent.city] }}</span>
							-
							<span>{{ CodeToText[info.agent.district] }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">详细地址：</div>
						<div class="con">
							<span>{{ info.agent.address }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">创建时间：</div>
						<div class="con">
							<span>{{ info.addtime }}</span>
						</div>
					</div>
					<div class="infoshow">
						<div class="title">简介：</div>
						<div class="con">
							<span>{{ info.intro }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisibleModifyProfile" width="520px" :close-on-click-modal="false">
			<div slot="title">
				<span class="el-icon-user"></span>
				<span class="padding-left-sm">修改资料</span>
			</div>
			<div v-loading="loadingModifyProfile" class="padding-right-xl">
				<el-form ref="formModifyProfile" :model="formModifyProfile" label-width="80px">
					<el-form-item label="头像" prop="avatar">
						<el-input v-model="formModifyProfile.avatar_file" autocomplete="off"></el-input>
						<el-upload
							class="avatar-uploader"
							action="#"
							list-type="picture-card"
							:auto-upload="true"
							:http-request="upload_upload"
							:on-remove="upload_remove"
							:on-change="upload_change"
							:before-upload="upload_before"
							:class="{ hide: hideUpload }"
							:file-list="avatar"
							accept="image/png, image/jpeg"
						>
							<i slot="default" class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请填写姓名', trigger: 'blur' }">
						<el-input v-model="formModifyProfile.name" autocomplete="off" maxlength="20" show-word-limit style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile" :rules="{ required: true, message: '请填写手机号', trigger: 'blur' }">
						<el-input v-model="formModifyProfile.mobile" autocomplete="off" maxlength="11" show-word-limit style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="性别" prop="gender">
						<el-select v-model="formModifyProfile.gender" clearable style="width: 220px;">
							<el-option label="男" value="男"></el-option>
							<el-option label="女" value="女"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="生日" prop="birthday">
						<el-date-picker v-model="formModifyProfile.birthday" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="QQ号码" prop="qq"><el-input v-model="formModifyProfile.qq" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="微信" prop="weixin"><el-input v-model="formModifyProfile.weixin" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="邮箱" prop="email"><el-input v-model="formModifyProfile.email" autocomplete="off"></el-input></el-form-item>
					<el-divider></el-divider>
					<el-form-item>
						<el-button type="primary" @click="formSubmitModifyProfile('formModifyProfile')">确 定</el-button>
						<el-button @click="dialogVisibleModifyProfile = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			dialogVisibleModifyProfile: false,
			info: {
				account: {},
				agent: {},
				profile: {}
			},
			loadingModifyProfile: false,
			formModifyProfile: {},
			upload_avatar:null,
			avatar:[{
				name:'',
				url:''
			}],
			hideUpload:false
		};
	},
	beforecreate: function() {},
	created: function() {
		const loading = this.$loading({
			lock: true,
			text: '加载中...',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		this.$http.post('/server/index.php?m=user/index&a=getinfo', {}).then(
			res => {
				loading.close();
				if (typeof res.data != 'object') {
					this.$alert(res.data ? res.data : '(无返回数据)', {
						title: '返回数据格式错误',
						type: 'error'
					});
				} else {
					if (res.data.result == 'ok') {
						this.info = res.data.data.user;
						if(res.data.data.user.profile.avatar){
						this.avatar[0].url=res.data.data.user.profile.avatar;
						this.hideUpload=true;
						}
					} else {
						this.$alert(res.data.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				}
			},
			r => {
				loading.close();
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		upload_upload(p) {},
		upload_before(file) {
			if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
				this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
				return false;
			}
			if (file.size / 1024 / 1024 >1) {
				this.$message.error('上传图片大小不能超过 1MB!');
				return false;
			}
		},
		upload_exceed(file, fileList) {
			this.$message.error('上传的图片超过最多限制');
		},
		upload_change(file, fileList) {
			this.upload_avatar = file;
			this.hideUpload = true;
		},
		upload_remove(file, fileList) {
			this.upload_avatar = null;
			this.hideUpload = false;
		}
	}
};
</script>

<style>
.infoshow .title {
	min-width: 160px;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	border-radius: 500px;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 128px;
	height: 128px;
	line-height: 128px;
	border-radius: 500px;
	text-align: center;
}
.hide .el-upload--picture-card {
	display: none;
}
.el-upload-list__item-thumbnail{
	border-radius: 500px;
}
.el-upload-list--picture-card .el-upload-list__item{
	border-radius: 500px;
}
</style>
